import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // Defaults to localStorage
import { persistStore, persistReducer } from "redux-persist";
import communityReducer from "../Services/Community/CommunitySlice/communitySlice";
import communitybyNameReducer from "../Services/Community/CommunitySlice/communityByCommunityNameSlice";
import communityByIdReducer from "../Services/Community/CommunitySlice/communityByIdSlice";
import userLoginReducer from "../Services/Login/LoginSlice/loginSlice";
import forgotPasswordReducer from "../Services/Login/LoginSlice/ForgotPasswordslice";
import otpVerificationReducer from "../Services/Login/LoginSlice/otpverificationSlice";
import userResetPasswordReducer from "../Services/Login/LoginSlice/ResetPasswordSlice";
import userSignUpReducer from "../Services/Signup/SignupSlice/SignupSlice";
import fetchUserTypeReducer from "../Services/Signup/SignupSlice/userTypeSlice";
import idReducer from "../Services/Community/CommunitySlice/idSlice";
import communityDocNameReducer from "../Services/Community/CommunitySlice/communityDocName";
import createNewCommunitySlice from "../Services/Community/CommunitySlice/createNewCommunitySlice";
import createNewCommunityGptSlice from "../Services/Community/CommunitySlice/createNewCommunityGptSlice";
import vendorCheckOrCreateSlice from "../Services/Community/CommunitySlice/vendorCheckOrCreate";
import communityUpdateSlice from "../Services/Community/CommunitySlice/communityUpdateSlice";
import uploadDocumentsSlice from "../Services/DocumentUpload/documentSlice/documentUploadSlice";
import getDocTypeApiSlice from "../Services/DocumentUpload/documentSlice/doctypeSlice";
import getAllDocumentSlice from "../Services/DocumentUpload/documentSlice/getDocumentSlice";
import updateDocumentSlice from "../Services/DocumentUpload/documentSlice/updateDocumentSlice";
import getDocumentbyIdSlice from "../Services/DocumentUpload/documentSlice/documentGetByIdSlice";
import healthVendorCheckOrCreateSlice from "../Services/Community/CommunitySlice/healthVendorCheckOrCreate";
import fetchProfileDataSlice from "../Services/Profile/ProfileSlice";
import uiReducer from "../Services/DashboardHeader/uiSlice";
import claimCommunitySlice from "../Services/Community/ClaimCommunity/claimCommunitySlice";
import fetchclaimCommunitySlice from "../Services/Community/ClaimCommunity/fetchClaimCommunitySlice";
import updateClaimSlice from "../Services/Community/ClaimCommunity/updateClaimSlice";
import updateProfileApiSlice from "../Services/updateProfile/updateProfileSlice";
import HomeOwnerAllDataSlice from "../Services/Homeowner/homeownerSlice/getHomeOwnerSlice";
import HomeOwnerCreateDataSlice from "../Services/Homeowner/homeownerSlice/createCommuniHomeOwnerSlice";
import getAllAssignHomeOwnerDataSlice from "../Services/Homeowner/homeownerSlice/getAllAssignHomeOwnerSlice";
import educationVendorCheckOrCreateSlice from "../Services/Community/CommunitySlice/educationVendorCheckOrCreate";
import fetchAssignedCommunityToHomeownerSlice from "../Services/Homeowner/homeownerSlice/fetchAssignedCommunityToHomeownerSlice";
import userResendOtpSlice from "../Services/Login/LoginSlice/resendOtpSlice";
import chatbotPostApiSlice from "../Services/ChatBotApi/chatbotslice";
import fetchCommunityDatabyClaimStatusSlice from "../Services/Community/CommunitySlice/fetchAllCommunityByClaimStatusSlice";
import fetchCommunityDataByUserIdClaimStatusSlice from "../Services/Community/CommunitySlice/fetchCommunityByUserIdSlice";
import addMultipleHomeOwnersSlice from "../Services/Homeowner/homeownerSlice/addMultipleHomeOwners";
import factCheckPostApiSlice from "../Services/FactCheck/factCheckSlice";
import submitUpdatePostApiSlice from "../Services/SubmitUpdate/submitUpdateSlice";
import fetchDashboardCountAssociateSlice from "../Services/dashboarCountAssociate/associateDashboardCountSlice";
import fetchTaskStatusSlice from "../Services/DocumentUpload/documentSlice/fetchTaskStatusSlice";
import getCommunityNameSlice from "../Services/Community/CommunitySlice/getCommunityNameSlice";
import fetchCommunityHomeownerSlice from "../Services/Community/CommunitySlice/CommunityHomeownerSlice";
import fetchProductListSlice from "../Services/Subscription/SubscriptionSlice/fetchProductListSlice";
import fetchUserSubscriptionsByIdSlice from "../Services/Subscription/SubscriptionSlice/fetchUserSubscriptionsByIdSlice";
import fetchCommunityDataByUserIdSlice from "../Services/Community/CommunitySlice/fetchCommunityDataByUserIdSlice";
import realtorWebcardApiSlice from "../Services/Realtor/RealtorSlice/RealtorSlice"
import getVendorsByTypeSlice from "../Services/Vendor/VendorSlice/getVendorsByTypeSlice"
import realtorSubscriptionApiSlice from "../Services/Realtor/RealtorSlice/RealtorSubscriptionSlice"
import realtorFetchSubscriptionSlice from "../Services/Realtor/RealtorSlice/realtorFetchSubscriptionSlice"
import realtorCancelSubscriptionSlice from "../Services/Realtor/RealtorSlice/RealtorCancelSubscriptionSlice"
import fetchCommunityDataWithPaginationSlice from "../Services/Community/CommunitySlice/communityByPaginationSlice"
import fetchRealtorDetailsSlice from "../Services/Community/CommunitySlice/fetchRealtorDetailsSlice"
import fetchVendorSubTypeListSlice from '../Services/Signup/SignupSlice/SubVendorList'
import fetchAllCitiesSlice from "../Services/Vendor/VendorSlice/getAllCitiesSlice"
import vendorFetchSubscriptionSlice from "../Services/Vendor/VendorSlice/fetchVendorSubscriptionSlice"
import fetchBannerImageSlice from "../Services/Vendor/VendorSlice/fetchBannerImageSlice"
import vendorSubscriptionSlice from "../Services/Vendor/VendorSlice/subscriptionByVendor"
import fetchSubscribedVendors from "../Services/Vendor/VendorSlice/getSubscribedVendorList"
import fetchBillingHistorySlice from "../Services/Vendor/VendorSlice/fetchBillingHistorySlice"
import fetchGroupDataSlice from "../Services/Community/CommunitySlice/fetchGroupDataSlice"

// Configure Redux Persist
const persistConfig = {
  key: "ui",
  storage,
  whitelist: ["ui"], // Persist only the ui slice
};

// Combine Reducers
const rootReducer = combineReducers({
  community: communityReducer,
  communityByName: communitybyNameReducer,
  communityById: communityByIdReducer,
  userLogin: userLoginReducer,
  forgotPassword: forgotPasswordReducer,
  otpVerification: otpVerificationReducer,
  userResetPassword: userResetPasswordReducer,
  userSignUp: userSignUpReducer,
  fetchUserType: fetchUserTypeReducer,
  id: idReducer,
  communityDocName: communityDocNameReducer,
  createNewCommunity: createNewCommunitySlice,
  createNewCommunityGpt: createNewCommunityGptSlice,
  vendorCheckOrCreate: vendorCheckOrCreateSlice,
  communityUpdate: communityUpdateSlice,
  healthVendorCheckOrCreate: healthVendorCheckOrCreateSlice,
  getDocType: getDocTypeApiSlice,
  uploadDocuments: uploadDocumentsSlice,
  getAllDocument: getAllDocumentSlice,
  updateDocument: updateDocumentSlice,
  fetchProfileData: fetchProfileDataSlice,
  getDocumentbyId: getDocumentbyIdSlice,
  ui: uiReducer,
  claimCommunity: claimCommunitySlice,
  fetchclaimCommunity: fetchclaimCommunitySlice,
  updateClaim: updateClaimSlice,
  profileUpdate: updateProfileApiSlice,
  HomeOwnerAllData: HomeOwnerAllDataSlice,
  HomeOwnerCreateData: HomeOwnerCreateDataSlice,
  getAllAssignHomeOwnerData: getAllAssignHomeOwnerDataSlice,
  educationVendorCheckOrCreate: educationVendorCheckOrCreateSlice,
  fetchAssignedCommunityToHomeowner: fetchAssignedCommunityToHomeownerSlice,
  userResendOtp: userResendOtpSlice,
  chatbotPostApi: chatbotPostApiSlice,
  fetchCommunityDatabyClaimStatus: fetchCommunityDatabyClaimStatusSlice,
  fetchCommunityDataByUserIdClaimStatus:
    fetchCommunityDataByUserIdClaimStatusSlice,
  addMultipleHomeOwners: addMultipleHomeOwnersSlice,
  factCheckPostApi: factCheckPostApiSlice,
  submitUpdatePostApi: submitUpdatePostApiSlice,
  fetchDashboardCountAssociate: fetchDashboardCountAssociateSlice,
  fetchTaskStatus: fetchTaskStatusSlice,
  getCommunityName: getCommunityNameSlice,
  fetchCommunityHomeowner: fetchCommunityHomeownerSlice,
  fetchProductList: fetchProductListSlice,
  fetchUserSubscriptionsById: fetchUserSubscriptionsByIdSlice,
  fetchCommunityDataByUserId: fetchCommunityDataByUserIdSlice,
  realtorWebcard: realtorWebcardApiSlice,
  getVendorsByType: getVendorsByTypeSlice,
  realtorSubscription: realtorSubscriptionApiSlice,
  realtorFetchSubscription: realtorFetchSubscriptionSlice,
  realtorSubscriptionCancel: realtorCancelSubscriptionSlice,
  fetchCommunityDataWithPagination: fetchCommunityDataWithPaginationSlice,
  fetchRealtorDetails: fetchRealtorDetailsSlice,
  vendorSubtype: fetchVendorSubTypeListSlice,
  fetchAllCities: fetchAllCitiesSlice,
  vendorFetchSubscription: vendorFetchSubscriptionSlice,
  fetchBannerImage: fetchBannerImageSlice,
  vendorSubscription: vendorSubscriptionSlice,
  vendorSubscribed: fetchSubscribedVendors,
  fetchBillingHistory: fetchBillingHistorySlice,
  fetchGroupData: fetchGroupDataSlice
});

// Persisted Reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure Store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these redux-persist actions
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store); // Export persistor
export default store; // Export store
